import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { filterObj } from '@/utils/util';
import { getAction } from '@/api/manage';
export default {
  name: 'SelectTenantAiDeviceModal',
  components: {},
  data: function data() {
    return {
      title: 'Ai终端管理下发',
      queryParam: {},
      columns: [{
        title: '站点名称',
        align: 'center',
        dataIndex: 'siteName'
      }, {
        title: '设备点名称',
        align: 'center',
        dataIndex: 'name'
      }, {
        title: 'Ai设备编号',
        align: 'center',
        dataIndex: 'aiDeviceCode'
      }, {
        title: '平台类型',
        align: 'center',
        dataIndex: 'apiType_dictText'
      }, {
        title: '视频设备类型',
        align: 'center',
        dataIndex: 'deviceType_dictText'
      }],
      dataSource: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: function showTotal(total, range) {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      selectedRowKeys: [],
      selectionRows: [],
      visible: false,
      toggleSearchStatus: false,
      faceId: ''
    };
  },
  created: function created() {},
  methods: {
    loadData: function loadData(arg) {
      var _this = this;

      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      params.tenantId = window.localStorage.getItem('tenant');
      getAction('/ai/face/queryTenantAiDevicePage', params).then(function (res) {
        if (res.success) {
          _this.dataSource = res.result.records;

          _this.dataSource.forEach(function (e) {
            e.faceId = _this.faceId;
          });

          _this.ipagination.total = res.result.total;
        }
      });
    },
    add: function add(faceId) {
      this.visible = true;
      this.queryParam = {};
      this.faceId = faceId;
      this.loadData(); // this.edit()
    },
    // edit() {
    //   this.queryParam = {}
    //   this.loadData()
    // },
    getQueryParams: function getQueryParams() {
      var param = Object.assign({}, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryField: function getQueryField() {
      var str = 'id,';

      for (var a = 0; a < this.columns.length; a++) {
        str += ',' + this.columns[a].dataIndex;
      }

      return str;
    },
    onSelectChange: function onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    searchReset: function searchReset() {
      var that = this;
      Object.keys(that.queryParam).forEach(function (key) {
        that.queryParam[key] = '';
      });
      that.loadData(1);
    },
    handleTableChange: function handleTableChange(pagination, filters, sorter) {
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }

      this.ipagination = pagination;
      this.loadData();
    },
    handleCancel: function handleCancel() {
      this.selectionRows = [];
      this.selectedRowKeys = [];
      this.visible = false;
    },
    handleOk: function handleOk() {
      this.$emit('choseArchive', this.selectionRows);
      this.handleCancel();
    },
    searchByquery: function searchByquery() {
      this.loadData(1);
    },
    handleToggleSearch: function handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus;
    }
  }
};